import { Product } from "../gobalType";

export function normalizePlantApiResponse(raw: unknown): Product[] {
  if (Array.isArray(raw)) return raw as Product[];
  if (
    raw &&
    typeof raw === "object" &&
    Array.isArray((raw as { data?: unknown }).data)
  ) {
    return (raw as { data: Product[] }).data;
  }
  return [];
}
